export const TrackingDependencyTypes = {
  InternalUserService: Symbol.for('InternalUserService'),
  TrackingProviderConfig: Symbol.for('TrackingProviderConfig'),
  TrackingService: Symbol.for('TrackingService'),
};
